import { OptionGroup } from '@joor/design-system'
import { useSelector } from 'react-redux'

import { BillingAddress, OrderBilling } from '__generated__/atlas-types'

import { isAccountTypeBrand as isAccountTypeBrandSelector } from 'store/currentUser/selectors'

import { getBillingAddressOptions } from '../../Forms/BillingAddressForm/billingAddressForm.utils'
import { OptionsRecord, getAddressesOptionGroup } from '../../Forms/forms.utils'
import { RetailerLocation } from './useAddressModalData'

type UseBillingOptionsParams = {
  billingAddresses?: BillingAddress[]
  primaryLocation?: RetailerLocation
  retailerLocations?: RetailerLocation[]
  orderBilling?: OrderBilling | undefined
}

export function useBillingOptions({
  billingAddresses = [],
  retailerLocations,
  primaryLocation,
  orderBilling,
}: UseBillingOptionsParams) {
  const isAccountTypeBrand = useSelector(isAccountTypeBrandSelector)
  const addressOptionsData: OptionsRecord = getBillingAddressOptions({
    billingAddresses,
    retailerLocations,
    primaryLocation,
    billing: orderBilling,
    isAccountTypeBrand,
  })

  const addressesOptionGroup: OptionGroup[] = getAddressesOptionGroup(
    isAccountTypeBrand,
    addressOptionsData,
  )

  return {
    aggregatedBillingOptions: addressOptionsData.aggregateOptions,
    billingAddressesOptionGroup: addressesOptionGroup,
  }
}
